import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { openDialog, closeDialog } from '../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { OperacionesCubicajeView } from '../components/OperacionesCubicajeView'
import { OperacionEliminarCubicaje } from '../operacionEliminarCubicaje/containers/OperacionEliminarCubicaje'
import { OperacionModificarCubicaje } from '../operacionModificarCubicaje/containers/OperacionModificarCubicaje'
import { OperacionNuevoCubicaje } from '../operacionNuevoCubicaje/containers/OperacionNuevoCubicaje'

export const OperacionesCubicaje = connect(null, { openDialog, closeDialog })(
  memo(({ silo, openDialog, closeDialog }) => (
    <OperacionesCubicajeView
      silo={silo}
      openDialogNuevoCubicaje={() => openDialog(() => <OperacionNuevoCubicaje silo={silo} />, 'CUBICAJE_SILO')}
      openDialogModificarCubicaje={() => openDialog(() => <OperacionModificarCubicaje silo={silo} />, 'MODIFICAR_CUBICAJE_SILO')}
      openDialogEliminarUltimoCubicaje={() => openDialog(() => <OperacionEliminarCubicaje silo={silo} />, 'ELIMINAR_CUBICAJE_SILO')}
      cancelar={useCallback(() => {
        closeDialog('OPERACIONES_DE_CUBICAJE_DE_SILO')
      }, [closeDialog])}
    />
  ))
)
